import type { deUi } from './de.ui';

/** Türkçe arayüz metinleri. Referans: de.ui.ts */
export const trUi: Record<keyof typeof deUi, string> = {
  'nav.dashboard': 'Panel',
  'nav.statistics': 'İstatistik',
  'nav.balance': 'Bakiye',
  'nav.settings': 'Ayarlar',
  'nav.language': 'Dil',
  'nav.main': 'Ana menü',

  'action.close': 'Kapat',
  'action.confirm': 'Onayla',
  'action.change': 'Değiştir',
  'action.remove': 'Kaldır',
  'action.edit': 'Düzenle',

  'help.about': 'Açıklamayı göster',
  'help.aboutLabel': '{label} hakkında açıklama',

  'dashboard.title': 'Panel',
  'dashboard.welcome': 'Merhaba, {name}',
  'dashboard.balance': 'Bakiye',
  'dashboard.minutesToday': 'Bugünkü görüşme dakikası',
  'dashboard.activeCallers': 'Çevrimiçi temsilci',
  'dashboard.runningCalls': 'Süren görüşme',
  'dashboard.campaigns': 'Etkin kampanya',
  'dashboard.resultsToday': 'Bugünkü başarılı görüşme',
  'dashboard.noData': 'Henüz veri yok',
  'dashboard.help.balance': 'Mevcut ön ödemeli bakiyeniz. Bir görüşme dakikasının altına düşerse yeni arama başlatılamaz.',
  'dashboard.help.minutesToday': 'Bugün gerçekten bağlanan görüşme süresi. Çalma ve bekleme süresi sayılmaz.',
  'dashboard.help.activeCallers': 'Şu anda oturum açmış ve görüşme yapabilecek temsilciler.',
  'dashboard.help.runningCalls': 'Tam bu anda süren görüşmeler.',
  'dashboard.help.campaigns': 'Şu anda başlatılmış kampanyalar. Durdurulmuş ve arşivlenmiş olanlar sayılmaz.',
  'dashboard.help.resultsToday': 'Bugün başarılı olarak kapatılan görüşmeler.',
  'dashboard.quickStart': 'Nasıl başlarsınız',
  'dashboard.quickStartText': 'Bir kampanya oluşturun, kayıtlarınızı içe aktarın ve temsilcilerinize açın.',
  'dashboard.openCampaigns': 'Kampanyalara git',

  'soon.title': 'Bu bölüm henüz kullanıma hazır değil',
  'soon.statistics': 'Görüşme, temsilci ve kampanya raporları sonraki adımlardan birinde gelecek. Görüşmeleriniz şimdiden eksiksiz kaydediliyor.',
  'soon.campaignStatistics': 'Bu kampanyanın raporu sonraki adımlardan birinde gelecek.',
  'soon.campaignRecordings': 'Görüşme kayıtları sonraki adımlardan birinde gelecek.',
  'soon.hint': 'Buradan daha sonra devam edebilirsiniz; hiçbir şey kaybolmaz.',

  'balance.title': 'Bakiye',
  'balance.current': 'Mevcut bakiye',
  'balance.pricePerMinute': 'Görüşme dakikası ücreti',
  'balance.help.pricePerMinute': 'Yalnızca bağlanan görüşme süresi, her görüşme için tam dakikaya yuvarlanarak hesaplanır.',
  'balance.topUp': 'Bakiye yükle',
  'balance.topUpText': 'Yükleme kripto ödemeyle yapılır. Kartla ödeme şu an planlanmıyor.',
  'balance.amount': 'Euro cinsinden tutar',
  'balance.minimum': 'En az tutar',
  'balance.minimumHint': 'Her yükleme için en az {amount}.',
  'balance.payWithCrypto': 'Kripto ile yükle',
  'balance.history': 'Ödeme geçmişi',
  'balance.historyEmpty': 'Yüklemeleriniz ve diğer tüm kayıtlar burada görünür.',
  'balance.date': 'Tarih',
  'balance.amountColumn': 'Tutar',
  'balance.type': 'Tür',
  'balance.balanceAfter': 'Sonraki bakiye',
  'balance.note': 'Not',

  // --- Kayıt türleri ------------------------------------------------------
  'balance.type.topup_nowpayments': 'Bakiye yükleme',
  'balance.type.start_credit': 'Başlangıç bakiyesi',
  'balance.type.manual_credit': 'Alacak kaydı',
  'balance.type.manual_debit': 'Borç kaydı',
  'balance.type.phone_number_order': 'Telefon numarası siparişi',
  'balance.type.phone_number_refund': 'Numara siparişi iadesi',
  'balance.type.hosted_sip_monthly_fee': 'Aylık SIP temel ücreti',
  'balance.type.dialer_call': 'Görüşme ücretleri',
  'balance.type.hosted_sip_call': 'SIP hattı üzerinden görüşme ücretleri',

  // --- Bakiye hata mesajları ----------------------------------------------
  'error.billing.below_minimum': 'Lütfen en az {minTopUpAmount} yükleyin.',
  'error.billing.amount_invalid': "Lütfen 0'dan büyük bir tutar girin.",
  'error.billing.note_too_long': 'Not çok uzun. Lütfen kısaltın.',
  'error.billing.debit_exceeds_balance': 'Bakiye yetersiz. Kullanılabilir tutar: {available}.',
  'error.billing.already_booked': 'Bu kayıt zaten oluşturuldu.',
  'error.billing.provider_unavailable': 'Yükleme şu anda yapılamıyor. Lütfen destek ile iletişime geçin.',

  // --- Temsilci yönetimi --------------------------------------------------
  'callers.role': 'Rol',
  'callers.roleAdmin': 'Yönetici',
  'callers.roleCaller': 'Temsilci',
  'callers.roleOwner': 'Hesap sahibi',
  'callers.state': 'Erişim',
  'callers.stateActive': 'Etkin',
  'callers.stateInactive': 'Engelli',
  'callers.createTitle': 'Yeni temsilci oluştur',
  'callers.created': 'Hesap oluşturuldu.',
  'callers.help.username': 'Temsilci bu adla oturum açar. Tüm platformda benzersiz olmalıdır.',
  'callers.help.admin': 'Yöneticiler kampanya oluşturabilir, kayıtları yönetebilir ve yeni hesaplar açabilir.',
  'callers.setPasswordTitle': 'Yeni parola belirle',
  'callers.setPasswordText': 'Temsilci bundan sonra yalnızca yeni parolayla oturum açabilir. Açık oturum sona erer.',
  'callers.setPasswordAction': 'Parolayı belirle',
  'callers.deactivateTitle': 'Erişimi engelle',
  'callers.deactivateText': 'Bu hesap artık oturum açamaz. Süren oturum hemen sona erer. İstediğiniz zaman yeniden açabilirsiniz.',
  'callers.deactivateAction': 'Erişimi engelle',
  'callers.makeAdminTitle': 'Yönetici yetkisi ver',
  'callers.makeAdminText': 'Bu hesap bundan sonra kampanyaları, kayıtları ve diğer hesapları yönetebilir.',
  'callers.revokeAdminTitle': 'Yönetici yetkisini geri al',
  'callers.revokeAdminText': 'Bu hesap bundan sonra yalnızca görüşme yapabilir.',

  'dialog.campaignArchive': 'Kampanyayı arşivle',
  'dialog.campaignArchiveText': 'Kampanya normal listeden kaybolur. Kayıtlar ve görüşme geçmişi korunur, istediğiniz zaman geri getirebilirsiniz.',
  'dialog.campaignDelete': 'Kampanyayı sil',
  'dialog.campaignDeleteText': 'Kampanya ve tüm kayıtları kalıcı olarak silinir. Bu işlem geri alınamaz.',
  'dialog.contactDelete': 'Kaydı sil',
  'dialog.contactDeleteText': 'Kayıt kalıcı olarak silinir. İleride gerekebilecekse arşivlemek daha iyidir.',
  'dialog.modeChange': 'Kampanyanın çalışma biçimini değiştir',
  'dialog.accountDelete': 'Hesabı sil',
  'dialog.leaveCalling': 'Arama bölümünden çıkılsın mı?',
  'dialog.leaveCallingText': 'Çevirici durur ve artık çağrı alamazsınız.',
  'dialog.leaveCallingAction': 'Çık',

  'campaign.section.general': 'Genel',
  'campaign.section.generalHint': 'Ad, açıklama ve telefon numaralarının ülkesi.',
  'campaign.section.callers': 'Temsilciler',
  'campaign.section.callersHint': 'Kayıtların temsilciler arasında nasıl paylaştırıldığı.',
  'campaign.section.dialer': 'Çevirici',
  'campaign.section.dialerHint': 'Aynı anda kaç görüşme kurulduğu ve bir numaranın kaç kez yeniden denendiği.',
  'campaign.section.telephony': 'Telefon',
  'campaign.section.telephonyHint': 'Bu kampanya için telefon sağlayıcınızın hesabı.',
  'campaign.section.inbound': 'Gelen çağrılar',
  'campaign.section.inboundHint': 'Müşterilerin bu kampanyada geri arayıp arayamayacağı.',
  'campaign.section.queue': 'Bekleme sırası',
  'campaign.section.queueHint': 'Boş temsilci yokken ne olacağı.',
  'campaign.section.recording': 'Kayıtlar',
  'campaign.section.recordingHint': 'Görüşmelerin kaydedilip kaydedilmeyeceği.',
  'campaign.section.data': 'Özel alanlar',
  'campaign.section.dataHint': 'Her kayıt için tutmak istediğiniz ek bilgiler.',
  'campaign.section.advanced': 'Gelişmiş ayarlar',

  'campaign.help.mode': 'Ortak havuzda tüm temsilciler aynı listeyi işler. Sabit atamada her kayıt tek bir temsilciye aittir ve diğerleri onu görmez.',
  'campaign.help.country': 'Ülke kodu olmayan numaraları doğru tamamlamak için gerekir - örneğin 0176… yerine +49176…',
  'campaign.help.parallelCalls': 'Bir temsilci boştayken aynı anda kaç numaranın arandığı. Yüksek değerler daha hızlı birini bulur ama müşterinin bekleme riskini artırır.',
  'campaign.help.parallelMode': 'Bu sayı her temsilci için mi yoksa tüm kampanya için mi geçerli?',
  'campaign.help.retry': 'Kimse açmadığında bir numaranın 24 saat içinde kaç kez yeniden deneneceği.',
  'campaign.help.mailbox': 'Telesekreterleri tanır ve bu görüşmeleri sonlandırır; böylece temsilcileriniz kayıt dinlemez.',
  'campaign.help.inbound': 'Müşterilerin bu kampanyada geri arayıp boş bir temsilciye ulaşmasını sağlar.',
  'campaign.help.queue': 'Boş temsilci yokken arayanları kısa süre sırada bekletir.',
  'campaign.help.queueWait': 'Bu süre sonunda kimse boşalmadıysa görüşme sonlandırılır.',
  'campaign.help.recording': 'Bu kampanyadaki görüşmelerin varsayılan olarak kaydedilip kaydedilmeyeceğini belirler.',
  'campaign.help.fields': 'Kayıt başına ek bilgiler, örneğin şehir veya sözleşme numarası. Görüşme sırasında ve CSV içe aktarmada görünür.',
  'campaign.help.required': 'Bir görüşme tamamlanmadan önce bu alanın doldurulmuş olması gerekir.',
  'campaign.help.sip': 'Telefon sağlayıcınızın hesap bilgileri. Bunlar olmadan bu kampanyada görüşme yapılamaz.',

  'campaign.settings.sip': 'Telefon sağlayıcısı',

  // --- Kampanyanın telefon sağlayıcısı ----------------------------------------
  'campaign.sip.provider': 'Sağlayıcı',
  'campaign.sip.providerHint': 'Yalnızca sizin için bir not - örn. TENIOS, dus.net veya sipgate.',
  'campaign.sip.host': 'SIP sunucusu',
  'campaign.sip.hostHint': 'Sağlayıcınızın verdiği adres - başında „sip:“ olmadan.',
  'campaign.sip.username': 'Kullanıcı adı',
  'campaign.sip.password': 'Şifre',
  'campaign.sip.passwordStored': 'Kayıtlı bir şifre var. Korumak için boş bırakın.',
  'campaign.sip.registration': 'Sağlayıcıda oturum açma gerekli',
  'campaign.sip.registrationHelp':
    'Sağlayıcıların çoğu bunu ister. Bilgilerinizde genellikle „kayıt“ veya „REGISTER“ olarak geçer.',
  'campaign.sip.advancedShow': 'Gelişmiş ayarları göster',
  'campaign.sip.advancedHide': 'Gelişmiş ayarları gizle',
  'campaign.sip.authId': 'Oturum kimliği',
  'campaign.sip.authIdHint': 'Yalnızca kullanıcı adından farklıysa doldurun.',
  'campaign.sip.realm': 'Realm',
  'campaign.sip.fromDomain': 'Gönderen alanı',
  'campaign.sip.fromDomainHint': 'Yalnızca sağlayıcınız sunucudan farklı bir alan isterse doldurun.',
  'campaign.sip.port': 'Port',
  'campaign.sip.portHint': 'Alışılmış 5060 portu için boş bırakın.',
  'campaign.sip.transport': 'Taşıma',
  'campaign.sip.transportDefault': 'Varsayılan',
  'campaign.sip.optional': 'Seçimlik.',
  'campaign.sip.expiration': 'Oturum geçerliliği (saniye)',
  'campaign.sip.expirationHint': 'Varsayılan için boş bırakın.',
  'campaign.sip.retryInterval': 'Yeni deneme aralığı (saniye)',
  'campaign.sip.retryIntervalHint': 'Varsayılan için boş bırakın.',
  'campaign.sip.saved': 'Erişim bilgileri kaydedildi.',
  'campaign.sip.test': 'Bağlantıyı test et',
  'campaign.sip.testing': 'Test ediliyor …',
  'campaign.sip.test.ok': 'Telefon hazır.',
  'campaign.sip.test.registered': 'Bağlandı - sağlayıcıda oturum açma başarılı.',
  'campaign.sip.test.registration_failed':
    'Sağlayıcıda oturum açma başarısız. Lütfen sunucuyu ve bilgileri kontrol edin.',
  'campaign.sip.test.rejected': 'Sağlayıcı erişim bilgilerini reddetti.',
  'campaign.sip.test.unreachable': 'Sağlayıcının sunucusuna ulaşılamıyor.',
  'campaign.sip.test.timeout': 'Sağlayıcı yanıt vermedi. Lütfen daha sonra tekrar deneyin.',
  'campaign.sip.test.busy': 'Bağlantı az önce kontrol edildi. Lütfen biraz bekleyip tekrar deneyin.',
  'error.sip.password_required': 'Lütfen telefon sağlayıcısının şifresini girin.',
  'error.sip.incomplete': 'Lütfen sunucu ve kullanıcı adını girin.',
};
